<template>
  <BasePage>
    <!-- <LiAction /> -->
    <!-- <SearchFormType /> -->
    <!-- <SearchFormSort /> -->
    <!-- <BiddingTable /> -->
    <!-- <newBiddingTable /> -->
    <Content />
    <Footer />
    <!-- <RightNav /> -->
  </BasePage>
</template>

<script>
import imgData from "@/data";
import { reactive } from "vue";
import Footer from "@/components/BasePage/components/Footer/Footer.vue";
import RightNav from "@/components/BasePage/components/RightNav/RightNav.vue";
import BasePage from "@/components/BasePage/BasePage";
import LiAction from "./components/LiAction/LiAction";
import Content from "./components/content/content";
import SearchFormType from "./components/SearchFormType/SearchFormType";
import SearchFormSort from "./components/SearchFormSort/SearchFormSort";
// import BiddingTable from "./components/BiddingTable/BiddingTable";
import newBiddingTable from "./components/newBiddingTable/newBiddingTable";
export default {
  components: {
    BasePage,
    RightNav,
    Content,
    Footer,
    LiAction,
    SearchFormType,
    SearchFormSort,
    // BiddingTable,
    newBiddingTable,

  },
  setup() {
    const data = reactive({});

    return {
      ...data,
      ...imgData,
    };
  },
};
</script>

<style scoped>
</style>

